export default __webpack_public_path__ + "assets/txt.d0b32e515641b99e8e31165279361eb4.png";